import type { ComponentChildren } from 'preact';
import { Hero } from './Hero.tsx';
import { MarketingFooter } from './MarketingFooter.tsx';
import { useDocumentTitle } from '../../hooks/useDocumentTitle.ts';
import { useT } from '../../i18n.ts';
import '../../styles/marketing.css';

interface LegalPageProps {
  title: string;
  lede: string;
  // The date the text last changed, shown under the heading so a reader
  // can tell whether the version they agreed to is the one in front of them.
  effectiveDate: string;
  children: ComponentChildren;
}

// Shell for the privacy policy and terms of service: the marketing hero for
// the heading, a single readable column for the text, and the site footer.
export function LegalPage({ title, lede, effectiveDate, children }: LegalPageProps) {
  const t = useT();
  useDocumentTitle(title);

  return (
    <div className="mkt-page">
      <Hero eyebrow={t('legal.eyebrow')} title={title} lede={lede} />
      <section className="mkt-section">
        <div className="mkt-container-narrow mkt-legal" data-gp-name="legal-text">
          <p className="mkt-legal-effective">{t('legal.effective', { date: effectiveDate })}</p>
          {children}
        </div>
      </section>
      <MarketingFooter />
    </div>
  );
}
